import {Menu} from './menu.model';
import {Injector} from '@angular/core';
import { MenuItem } from './menuitem.model';

export class NavbarMenu {

  public evaluating: boolean = null;

  constructor(public menus: Menu[]) {}

  public getPaths(injector: Injector): string[] {
    const paths = [];
    this.menus.forEach(menu => {
      menu.getChildren().filter(children=>children instanceof Menu)
      .map(children=>children as Menu).forEach( menu => {
        menu.getChildren().filter(children=>children instanceof MenuItem)
        .map(children=>children as MenuItem).forEach(menuitem => {
          if (!menuitem.dependent) {
            // il path viene preso dal servizio ...
            menuitem.pathToCheck = injector.get(menuitem.name).getApiPath()+"/menu";
            paths.push(menuitem.pathToCheck);
          }
        });
      });
    });
    this.menus.forEach(menu => {
      menu.getChildren().filter(children=>children instanceof MenuItem)
      .map(children=>children as MenuItem).forEach( menuitem => {
        if (!menuitem.dependent) {
          // il path viene preso dal servizio ...
          menuitem.pathToCheck = injector.get(menuitem.name).getApiPath()+"/menu";
          paths.push(menuitem.pathToCheck);
        }
      });
    });
    return paths;
  }

  public evaluate(permittedPaths) {
    this.menus.forEach(menu => {
      menu.getChildren().filter(children=>children instanceof Menu)
      .map(children=>children as Menu).forEach( menu => {
        menu.getChildren().filter(children=>children instanceof MenuItem)
        .map(children=>children as MenuItem).forEach(menuitem => {
          if (!menuitem.dependent) {
            if (permittedPaths.includes(menuitem.pathToCheck)) {
              menuitem.active = true;
              if (menuitem.depending) {
                menuitem.depending.forEach(depending => {
                  depending.active = true;
                });
              }
            }
          }
        });
      });
    });    
    this.menus.forEach(menu => {
      menu.getChildren().filter(children=>children instanceof MenuItem)
      .map(children=>children as MenuItem).forEach( menuitem => {
        if (!menuitem.dependent) {
          if (permittedPaths.includes(menuitem.pathToCheck)) {
            menuitem.active = true;
            if (menuitem.depending) {
              menuitem.depending.forEach(depending => {
                depending.active = true;
              });
            }
          }
        }
      });
    });
  }
}
